import { useEffect } from 'react';

/**
 * 处理全局拖拽移动的钩子函数
 */
interface UseGlobalDragMoveProps {
  /** 是否启用事件监听 */
  enabled: boolean;
  /** 移动事件回调 */
  onMove: (e: MouseEvent | TouchEvent) => void;
  /** 结束事件回调 */
  onEnd: (e: MouseEvent | TouchEvent) => void;
}

export const useDragMove = ({ enabled, onMove, onEnd }: UseGlobalDragMoveProps) => {
  useEffect(() => {
    if (!enabled) return;

    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('mouseup', onEnd);
    window.addEventListener('touchend', onEnd);

    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('mouseup', onEnd);
      window.removeEventListener('touchend', onEnd);
    };
  }, [enabled, onMove, onEnd]);
};
